import styled from "styled-components";

export const CollectionPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 2rem;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        padding: 0 2rem;
        padding-top: 2rem;
    `}

`;

export const CollectionContent = styled.div`
    width: 80%;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}
`;

export const CollectionHeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 270px;
    width: 80%;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}
`;

export const CollectionHeaderContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 2rem;
    //min-height: calc(100% - 76px);
    //background-color: ${({ theme }) => theme.newBg1};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right;
    border-radius: 0.5rem 0.5rem 0 0;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    `}
`;

export const CollectionHeaderBottomWrapper = styled.div`
    width: 100%;
    background-color: ${({ theme }) => theme.newBg2};
    border-radius: 0 0 0.5rem 0.5rem;
    transition: max-height 0.2s linear;
    padding: 0.5rem 0;
`;

export const CollectionHeaderBottom = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    flex: 1;
`;

export const CollectionImage = styled.div`
    height: 150px;
    width: 150px;
    z-index: 1;
    background-color: ${({ theme }) => theme.newBg2};
    border-radius: 50%;
    margin-right: 1rem;
    box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        align-self: center;
    `}
    
    > img {
        width: 150px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        object-fit: cover;
    }
`;

export const CollectionInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 60%;
    color: #fff;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
        font-size: 0.8rem;
    `}

`;

export const CollectionTitle = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 1rem 0;
    width: 100%;
    display: flex;
    align-items: center;
    svg {
        width: 1.5rem;
        margin-right: 0.5rem;
        fill: rgb(32, 129, 226);
    }
`

export const CollectionSocial = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 1rem;
    height: 100%;
`;

export const CollectionSocialItem = styled.a`
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 10px;
    margin-right: 10px;
    background-color: #fff;
    color: ${({ theme }) => theme.newBg1};
    &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow};
        transform: translateY(-5px);
        transition: all 0.3s ease-in-out;
        cursor: pointer;
    }
`;

export const CollectionStatisticItem = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 150px;
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    margin: 0.5rem;
    box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.2);

    > span {
        font-size: 0.8rem;
        font-weight: 500;
        margin-bottom: 0.5rem;
        color: ${({ theme }) => theme.yetiBlue};
    }

    > div {
        font-size: 0.9rem;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 120px;
        display: flex;
        align-items: center;

        > img {
            width: 1rem;
            height: 1rem;
            margin-left: 5px;
        }
    }
`

export const CollectionLikeCount = styled.div`
    height: 32px;
    min-width: 64px;
    max-width: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: bold;
    z-index: 1;
    background: ${({ theme }) => theme.pageBg};
    border-radius: 0.5rem;
    margin: 0 0.5rem;

    > svg {
        margin-right: 5px;
        &:only-child {
            margin-right: 0;
        }
    }

    &.liked,
    &:hover {
        cursor: pointer;
        > svg {
            color: ${({ theme }) => theme.red2};
            font-size: 0.9rem;
        }
    }
`;

export const CollectionShowOnSaleToggle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem;

    > div {
        margin-left: 0.5rem;
    }
`;